import React from "react";
import { Link } from "gatsby";
const Privacy = () => (
    <>
      <main id="main" className="site-main main my-3">
        <section className="section">
          <div className="container">
            <div className="row">
              <div id="primary" className="content-area col-md-8 mx-auto">
                <div id="content" className="site-content" role="main">
                  <article
                    id="post-108"
                    className="post-108 page type-page status-publish hentry"
                  >
                    <header className="entry-header">
                      <h1 data-sal="slide-up" className="entry-title text-primary">Privacy Policy</h1>
                    </header>
                    <div className="entry-content">
                      <p>
                        Below are our Privacy Policy, which outline a lot of
                        legal goodies, but the bottom line is it’s our aim to
                        always take care of both you, as a customer, or as a
                        seller on our platform.
                      </p>
                      <ol>
                        <li>
                          <strong>Usage Data</strong>
                          <ol>
                            <li>
                              Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data.

                            </li>

                            <li>Your access to and use of the Service is conditioned on Your acceptance of and compliance with these Terms and Conditions. These Terms and Conditions apply to all visitors, users and others who access or use the Service.</li>


                          </ol>
                        </li>
                        <li>
                          <strong>Links to Other Websites</strong>
                          <ol>
                            <li>
                              Our Service may contain links to third-party web sites or services that are not owned or controlled by the Company.
                            </li>
                            <li>
                              The Company has no control over, and assumes no responsibility for, the content, privacy policies, or practices of any third party web sites or services. You further acknowledge and agree that the Company shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with the use of or reliance on any such content, goods or services available on or through any such web sites or services.

                            </li>
                            <li>
                              We strongly advise You to read the terms and conditions and privacy policies of any third-party web sites or services that You visit.
                            </li>
                          </ol>
                        </li>
                        <li>
                          <strong>Termination</strong>
                          <ol>
                            <li>
                              We may terminate or suspend Your access immediately, without prior notice or liability, for any reason whatsoever, including without limitation if You breach these Terms and Conditions.
                            </li>
                          </ol>
                        </li>
                        <li>
                          <strong>Governing Law</strong>
                          <ol>
                            <li>
                              The laws of the Country, excluding its conflicts of law rules, shall govern this Terms and Your use of the Service. Your use of the Application may also be subject to other local, state, national, or international laws.
                            </li>
                            <li>
                              The issue of refunds is at the complete discretion
                              of Bootstrap Themes.
                            </li>
                          </ol>
                        </li>


                        <li>
                          <strong>
                            Contact Us
                          </strong>
                          <ol>
                            <li>
                              If you have any questions about these Terms and Conditions, You can contact us:
                            </li>
                            <li><a href="mailto:bizdamn@gmail.com">bizdamn@gmail.com</a></li>
                            <li><a href="https://bizdamn.tech/">Website</a></li>
                          </ol>

                        </li>
                      </ol>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
  export default Privacy;